export default {
      id: "departments-usage",
      viewBox: "64 64 896 896",
      url: __webpack_public_path__ + "img/icons.adde2a28.svg#departments",
      toString: function () {
        return this.url;
      }
    }